import React,{ forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { FormItem } from '../../common/formValidations';
import fetchWrapper from '../../helpers/fetchWrapper';
import { Button, Form, Row } from 'antd';
import { MultiSelect } from 'react-multi-select-component';
import SearchWrapper from './SearchArea.style';
const removeElm = ['level_1', 'level_2', 'level_3', 'level_4', 'level_5', 'level_6', 'level_7', 'level_8'];
const exceptionalTypes = ['unit_hierarchy_bud_budget', 'unit_hierarchy_cost_center'];
const SearchComponent = forwardRef(function SearchComponent(
	{
		slug,
		callFrom,
		searchConfig,
		setQuery,
		defaultSearchValues = [],
		defaultSearchItems = [],
		getActiveFieldIds,
		btnName,
		showFilterBtn = true,
		extraConditions,
	},
	ref,
) {
	const [inputFields, setInputFields] = useState([]);
	const [selected, setSelected] = useState([]);
	const [count, setCount] = useState(0);
	const [options, setOptions] = useState([]);
	const [panels, setPanels] = useState({});
	const [initialValues, setInitialValues] = useState();
	const [unitHierarchyTypes, setUnitHierarchyTypes] = useState([]);
	const [form] = Form.useForm();

	useImperativeHandle(
		ref,
		() => {
			return {
				filter() {
					form.submit();
				},
			};
		},
		[],
	);

	const handleFields = (select) => {
		// set state for this component
		setSelected(select);

		const valueArr = select.map(function (item) {
			return item.value.toString();
		});

		// update options and selected fields
		fieldFilter(panels, valueArr, false);
	};

	// filter for select option
	const fieldFilter = (data, selectItem, checkDefault = true) => {
		if (!data) return;

		const modifiedSelectedItem = checkDefault
			? [...new Set([...selectItem, ...defaultSearchItems])]
			: [...new Set([...selectItem])];

		const search_fields = data.search_fields ?? [];
		const optionArr = [];

		search_fields.forEach(function (item) {
			const optItem = {
				label: item.label_name,
				value: item.search_panel_detail_id.toString(),
			};

			optionArr.push(optItem);
		});

		// set option
		setOptions(optionArr);

		const selectedArr = [];
		search_fields.forEach(function (item) {
			const optItem = {
				label: item.label_name,
				value: item.search_panel_detail_id.toString(),
			};
			if (modifiedSelectedItem.includes(item.search_panel_detail_id.toString())) {
				selectedArr.push(optItem);
			}
		});

		// set selected
		setSelected(selectedArr);

		// show select fields
		showSelectFields(data, modifiedSelectedItem);
	};

	// show select fields
	const showSelectFields = (data, selectItem) => {
		const search_fields = data.search_fields;
		const renderSwitch = (param) => {
			switch (param) {
				case 'WHERE LIKE':
					return 'WH-LK-';
				case 'WHERE EQUAL':
					return 'WH-EQ-';
				case 'WHERE TIME':
					return 'WH-TM-';
				case 'WHERE IN':
					return 'WH-IN-';
				case 'WHERE DATERANGE':
					return 'WH-DR-';
				case 'WHERE DATETIME':
					return 'WH-DT-';
				case 'WHERE RANGE':
					return 'WH-RG-';
				case 'HAVING LIKE':
					return 'HV-LK-';
				case 'HAVING EQUAL':
					return 'HV-EQ-';
				case 'HAVING IN':
					return 'HV-IN-';
				case 'HAVING DATERANGE':
					return 'HV-DR-';
				case 'HAVING DATETIME':
					return 'HV-DT-';
				case 'HAVING RANGE':
					return 'HV-RG-';
				default:
					return 'WH-LK-';
			}
		};

		// update fields
		const fields = [];
		const activeFieldIds = [];
		for (const [, cl] of search_fields.entries()) {
			const item = {
				input_type: cl?.input_type,
				label_name: cl?.label_name,
				input_name:
					data.prefix === true
						? renderSwitch(cl?.input_operation_type) + (cl?.input_name + '__' + cl?.input_type)
						: cl?.input_name + '__' + cl?.input_type,
				value: cl?.input_default_val ?? '',
				element_column: String(cl?.column_space),
				input_class: cl?.input_class,
				input_id: cl?.input_id,
				dropdown_slug: cl?.dropdown_slug,
				multiple: String(cl?.multiple || 0),
				input_placeholder: cl?.input_placeholder,
				dropdown_options: cl?.dropdown_options,
				input_label: cl?.input_label,
				input_value: cl?.input_value,
				required: cl?.required,
				disabled: cl?.disabled,
			};

			const { input_name, value } = item;

			setInitialValues((prev) => {
				return { ...prev, [input_name]: value };
			});

			if (selectItem.includes(String(cl?.search_panel_detail_id))) {
				fields.push(item);
				activeFieldIds.push(cl.search_panel_detail_id);
			}
		}
		getActiveFieldIds && getActiveFieldIds(activeFieldIds);
		setInputFields(fields);
	};

	// when submit form
	const onFinish = (values) => {
		if (values) {
			const search_data = [];
			for (const [nameWithType, value] of Object.entries(values)) {
				const [name, type] = nameWithType.split('__');
				if (!removeElm.includes(name)) {
					const field = {};
					if (unitHierarchyTypes?.includes(nameWithType)) {
						field.name = name;
						field.value =
							type === 'unit_hierarchy_cost_center'
								? values?.level_8
								: type === 'unit_hierarchy_bud_budget'
								? values?.level_7
								: [];
					} else {
						field.name = name;
						field.value = value;
					}
					field.value && search_data.push(field);
				}
			}
			if (setQuery) setQuery(search_data);
		} else {
			if (setQuery) setQuery(false);
		}
	};

	// for external search
	const getSearchFields = async () => {
		try {
			const response = await fetchWrapper.get(`master-grid/search-panel/${slug}`);
			if (!response?.error) {
				const searchData = response.data;
				setPanels(searchData);
				const selectedValue =
					searchData.session_filter && searchData.session_filter !== ''
						? searchData.session_filter.split(',').map((iNum) => iNum)
						: [];

				if (defaultSearchValues) {
					for(let  defaultSearch of defaultSearchValues){
						for(let field of searchData?.search_fields){
							if (field?.input_name == Object.keys(defaultSearch)[0]) {
								field.input_default_val = Object.values(defaultSearch)[0];
							}
						}
					}
					// defaultSearchValues?.forEach((defaultSearch) => {
					// 	searchData?.search_fields.forEach((field) => {
					// 		if (field?.input_name == Object.keys(defaultSearch)[0]) {
					// 			field.input_default_val = Object.values(defaultSearch)[0];
					// 		}
					// 	});
					// });
				}

				fieldFilter(searchData, selectedValue);
			}
		} catch (error) {
			console.log(error);
		}
	};

	const checkDefaultValues = (inputFields) => {
		const values = [];
		// inputFields?.map((item) => item?.value && values.push(item.value));
		for(let item of inputFields){
			if(item?.value){
				values.push(item.value)
			}
		}
		if (count === 0 && inputFields?.length > 0) {
			setCount((prev) => prev + 1);
			form.submit();
		}
	};

	const getExtraData = (input_name) => {
		try {
			const inputName = input_name?.split('-')?.slice(-1)[0] ?? null;
			const extraValue = inputName ? extraConditions[inputName.trim()] : '';
			return extraValue;
		} catch (error) {
			return '';
		}
	};

	// when window load
	useEffect(() => {
		if ((callFrom == 'grid' || callFrom == 'master') && searchConfig) {
			const selectedValue =
				searchConfig.session_filter && searchConfig.session_filter !== ''
					? searchConfig.session_filter.split(',').map((iNum) => iNum)
					: [];

			if (defaultSearchValues) {
				defaultSearchValues.forEach((defaultSearch) => {
					searchConfig.search_fields.forEach((field) => {
						if (field.input_name == Object.keys(defaultSearch)[0]) {
							field.input_default_val = Object.values(defaultSearch)[0];
						}
					});
				});
			}

			fieldFilter(searchConfig, selectedValue);
			setPanels(searchConfig);
		} else if (slug && slug != '') {
			getSearchFields();
		}
	}, [slug]);

	useEffect(() => {
		if (defaultSearchValues.length > 0 && count === 0) {
			setCount((prev) => prev + 1);
			const valueTimeouts = setTimeout(() => {
				form.submit();
			}, 10);
			return () => {
				clearTimeout(valueTimeouts);
			};
		}
	}, [defaultSearchValues]);

	useEffect(() => {
		form.resetFields();
		checkDefaultValues(inputFields);
		setUnitHierarchyTypes(
			inputFields.filter((field) => exceptionalTypes.includes(field.input_type)).map((field) => field.input_name),
		);
	}, [inputFields]);

	return (
		<SearchWrapper>
			<div className={`sa-wrapper ${callFrom}`}>
				<div className="sa-field-handler">
					<span className="sa-options-label">
						<i className="fa fa-search"></i> Select filter:
					</span>

					<MultiSelect options={options} value={selected} onChange={handleFields} labelledBy="Select" />
				</div>
				<p className='clearfix'></p>

				{inputFields?.length > 0 && (
					<Form form={form} onFinish={onFinish} initialValues={initialValues} >
						<Row gutter={16}>
							{inputFields?.map((field, index) => {
								return (
									<FormItem
										form={exceptionalTypes.includes(field.input_type) ? form : null}
										key={`${field.input_name}_${index}`}
										field={{ ...field, extra: getExtraData(field.input_name) ?? '' }}
									/>
								);
							})}
						</Row>
						{showFilterBtn && (
							<Button className="mb-3" type="primary" onClick={() => form.submit()}>
								{btnName || 'Filter Now'}
							</Button>
						)}
					</Form>
				)}
			</div>
		</SearchWrapper>
	);
});

export default SearchComponent;
